import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useState } from "react";
import { Button, Card, CardBody, CardFooter, CardHeader, Modal, ModalBody, ModalHeader } from "reactstrap";
import { NotesModalType } from "../../../../Types/MessengerType";

const NotesModal: React.FC<NotesModalType> = ({ toggle, modal }) => {
  const loremText: string = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at vulputate urna, sed dignissim arcu. Aliquam at ligula imperdiet, faucibus ante a, interdum enim. Sed in mauris a lectus lobortis condimentum. Sed in nunc magna. Quisque massa urna, cursus vitae commodo eget, rhoncus nec erat. Sed sapien turpis, elementum sit amet elit vitae, elementum gravida eros. In ornare tempus nibh ut lobortis. Nam venenatis justo ex, vitae vulputate neque laoreet a.`;
  const [editing, setEditing] = useState(false);

  return (
    <Modal className="notes-modal-main add-popup" isOpen={modal} toggle={toggle}>
      <ModalHeader><i className="ti-bookmark-alt" />notes
        <Button className="close" onClick={toggle}><span>×</span></Button>
      </ModalHeader>
      <ModalBody className="custom-scroll p-0">
        <Card>
          <CardHeader><h5>Inline Editor</h5></CardHeader>
          <CardBody>
            {editing ? (
              <CKEditor editor={ClassicEditor} data={loremText} />
            ) : (
              <div onClick={() => setEditing(!editing)}>
                <h1>{"Your title"}</h1>
                <p>{loremText}</p>
              </div>
            )}
          </CardBody>
          <CardFooter>
            <Button color="danger" size="sm" className="button-effect">Save</Button>
            <Button color="primary" size="sm" className="button-effect" onClick={toggle}>Cancel</Button>
          </CardFooter>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default NotesModal;
